import { useOne, useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type {
  PublicationListOut,
  SegmentDetailOut,
} from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { SEGMENT_DEFAULT_TAB, SEGMENT_SHOW_TABS } from '../constants';
import { SegmentShowHeader } from './SegmentShowHeader';
import { SegmentGeneralTab } from './SegmentGeneralTab';

export const SegmentShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<SegmentDetailOut>({
    resource: 'progress.segments',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  const { result: publication } = useOne<PublicationListOut>({
    resource: 'user_catalog.publications',
    id: record?.publication_id ?? 0,
    queryOptions: { enabled: !!record?.publication_id },
  });

  useRecordDocumentTitle('progress.segments', record?.segment_uuid);

  const [activeTab, onTabChange] = useShowTab(
    SEGMENT_SHOW_TABS,
    SEGMENT_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <SegmentShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <SegmentGeneralTab record={record} publication={publication} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
